import { withChartLayout } from 'components/common';
import BloodProductAdministrationRecord from 'components/features/chart/special-charts/blood-product-administration-record/BloodProductAdministrationRecord';

const BloodProductAdministrationRecordPage = withChartLayout('Blood Product Administration Record')(BloodProductAdministrationRecord);
export default BloodProductAdministrationRecordPage;
